import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { trackCtaClick } from "@/lib/analytics";

// Served from /public so index.html can preload the exact same URLs
// before the JS bundle is parsed (fastest possible LCP).
const HERO_SRC = "/hero-caracal-1920.webp";
const HERO_SRCSET =
  "/hero-caracal-768.webp 768w, /hero-caracal-1280.webp 1280w, /hero-caracal-1920.webp 1920w";

const HeroSection = () => {
  return (
    <section className="relative mt-14 lg:mt-20">
      <div className="relative w-full h-[calc(100vh-3.5rem)] lg:h-[calc(100vh-5rem)] overflow-hidden">
        <img
          src={HERO_SRC}
          srcSet={HERO_SRCSET}
          sizes="100vw"
          alt="Zwahili Game Lodge caracal"
          className="absolute inset-0 w-full h-full object-cover"
          width={1920}
          height={1251}
          loading="eager"
          decoding="async"
          // @ts-expect-error - fetchpriority is valid HTML, not yet in React DOM types
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/30" />

        <div className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <div className="max-w-2xl text-white">
            <p className="eyebrow">Private Luxury Safari Escape</p>
            <h1 className="font-heading text-lg sm:text-xl md:text-2xl lg:text-4xl xl:text-5xl leading-snug lg:leading-tight mt-3 mb-5 text-white">
              LUXURY MALARIA-FREE SAFARI, TWO HOURS FROM{" "}
              <span className="text-gold-gradient">JOHANNESBURG</span>.
            </h1>
            <p className="text-sm sm:text-base text-white/90 mb-6 max-w-xl leading-relaxed">
              10 rooms/suites, gourmet dining, an African spa and guided game
              drives and walks — reserved for a maximum of 20 guests.
            </p>
            <div className="flex flex-wrap gap-4 mb-6">
              <Button asChild variant="hero" size="lg" className="text-xs">
                <a
                  href="https://booking.roomraccoon.co.za/zwahili-game-lodge/en/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackCtaClick("Book Direct", "hero")}
                >
                  Book Direct — Best Rate <ArrowRight size={16} />
                </a>
              </Button>
              <Button asChild variant="heroOutline" size="lg" className="text-xs">
                <a
                  href="#rooms"
                  onClick={() => trackCtaClick("Explore the Lodge", "hero")}
                >
                  Explore the Lodge
                </a>
              </Button>
            </div>
            <p className="tracking-wider font-medium text-white whitespace-pre-line text-xs">
              <span className="inline-block mr-2 align-[-1px]">⭐</span>
              Rated 4.6 on Tripadvisor and 9 on Booking.com{"\n"}
              'Loved for exceptional food &amp; service'
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
